var DraggableEventNames;
(function (DraggableEventNames) {
  DraggableEventNames["DragStart"] = "DragStart";
  DraggableEventNames["Dragging"] = "Dragging";
  DraggableEventNames["DragEnd"] = "DragEnd";
})(DraggableEventNames || (DraggableEventNames = {}));
export default DraggableEventNames;